import axios from "../axios";
import {validateResponse} from "./utility";
import _ from "underscore";

export const getColor = async (uvc) => {

    let colorsList = []
    let interiorColorsList = []
    const headers = {
        'Content-Type': 'application/json',
    }
    const res = await axios.get(`/blackbook/color/${uvc}`, {
        headers: headers,

    })

    if (validateResponse(res)) {
        if (res.data.results && res.data.results.vehicle_colors) {

            let colors = res.data.results.vehicle_colors.category_list.find(element => element.name === 'Exterior Colors')
            if (colors && colors.color_list) {
                colors.color_list.forEach((item) => {
                    colorsList.push({...item})
                })
            } else {
                colors = res.data.results.vehicle_colors.category_list.find(element => element.name === 'Exterior & Interior Combinations')
                if (colors && colors.color_list) {
                    colors.color_list.forEach((item) => {
                        const colorsArray = item.name.split('/')
                        if (colorsArray.length > 1) {
                            const colorSwatchList = []
                            const interiorColorSwatchList = []

                            colorSwatchList.push(item.swatch_list[0])
                            interiorColorSwatchList.push(item.swatch_list[1])

                            colorsList.push({name: colorsArray[0], swatch_list: colorSwatchList})
                            interiorColorsList.push({name: colorsArray[1], swatch_list: interiorColorSwatchList})
                        }
                    })
                    colorsList = _.uniq(colorsList, 'name')
                    interiorColorsList = _.uniq(interiorColorsList, 'name')
                }
            }
            colors = res.data.results.vehicle_colors.category_list.find(element => element.name === 'Interior Colors')
            if (colors && colors.color_list) {
                colors.color_list.forEach((item) => {
                    interiorColorsList.push({...item})
                })
            }
            return {'exterior': colorsList, 'interior': interiorColorsList}
        } else {
            throw new Error('Invalid Blackbook Response')
        }
    } else {
        throw new Error('Blackbook API Error')
    }
}

export const getVin = async (vin, zip) => {

    const headers = {
        'Content-Type': 'application/json',
    }
    const res = await axios.get(`/blackbook/vin/${vin}/${zip}`, {
        headers: headers,
    })

    try {
        if (validateResponse(res)) {
            if (res.data.results && res.data.results.used_vehicles) {
                if (res.data.results.used_vehicles.used_vehicle_list.length) {
                    return res.data.results.used_vehicles.used_vehicle_list
                } else {
                    throw new Error('Vehicle not found. Please check the VIN')
                }
            } else {
                throw new Error('Invalid Blackbook Response')
            }
        } else {
            throw new Error('Blackbook API Error')
        }
    } catch (e) {
        console.log('e', e);
        throw new Error('We are unable to decode this VIN. Apologies for the inconvenience!');
    }
}